import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TemplateDto, UserProfileDto } from "../../interfaces";

export interface TemplateState {
  templates: TemplateDto[] | [];
}

const initialState: TemplateState = {
  templates: [],
};
const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    setProfile(state, action: PayloadAction<TemplateDto[] | []>) {
      state.templates = action.payload;
    },
  },
});

export const { setProfile } = templateSlice.actions;
export default templateSlice.reducer;
